import React, { Component } from 'react';
import Table from '../../../../components/Table';
import AdminUserFormModal from './components/AdminUserFormModal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DeleteAdminUserModal from './components/DeleteAdminUserModal';
import AdminUserDetailModal from './components/AdminUserDetailModal';
import './styles.css';


class AdminUsers extends Component {

    static contextTypes = { api: PropTypes.object };

    constructor(props) {
        super(props);

        this.state = {
            detailingPerson: false
        };

    }

    loadData = (tableState) => {
        this.tableState = tableState;
        this.context.api.people.get(tableState.page, tableState.pageSize, '@Class.People.people.get', {
            ...tableState.filters,
            'membership[exists]': false,
            'user[exists]':true
        }, 'users')
    };

    addPerson = (person, photo, registrationFile, academicResumeFile) => {

        this.setState({ addingLoading: true });
        this.context.api.people.create(person, '@Class.People.people.create', null, null, academicResumeFile)
            .then(() => {
                this.loadData(this.tableState);
                this.setState({ addingPerson: false, addingLoading: false });
            })
            .catch(() => {
                this.setState({ addingLoading: false });
            });
    };

    editPerson = (person, photo, registrationFile, academicResumeFile) => {

        this.setState({ editingLoading: true });
        this.context.api.people.edit(person.id, person, '@Class.People.people.edit', photo, registrationFile, academicResumeFile)
            .then(() => {
                this.loadData(this.tableState);
                this.setState({ editingPerson: false, editingLoading: false });
            })
            .catch(() => {
                this.setState({ editingLoading: false });
            });
    };

    deletePerson = (person) => {

        this.setState({ deletingPerson: false });
        this.context.api.people.delete(person.id, '@Class.People.people.delete', 'users');
    };


    tableDefinition =
        [
            {
                name: 'Acciones', accessor: (person) =>
                    <span className='actions-cell'>
                        <div>
                            <button className='btn btn-xs btn-primary' onClick={(e) => {
                                e.stopPropagation();
                                return this.setState({ editingPerson: person })
                            }}><i className='ti-pencil' /></button>
                                     &nbsp;
                            {person.user?
                                <span>
                                    <button className='btn btn-xs btn-danger' onClick={(e) => {
                                        e.stopPropagation();
                                        return this.setState({ deletingPerson: person })
                                    }}><i className='ti-trash' /></button>
                                             &nbsp;
                                         </span> :
                                null}
                        </div>
                    </span>

            },
            {
                name: 'Nombre de usuario',
                id: 'user.username',
                filterable: true,
                accessor: (person) => person.user && person.user.username,
            },
            {
                name: 'Nombre',
                id: 'name',
                filterable: true,
                accessor: 'name'
            }
        ];

    render() {
        return (
            <div className="container-fluid People">
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Usuarios administrativos</h4>
                            </div>
                            <div className="card-content">

                                <div className='buttonContainer'>
                                    <button className='btn btn-success btn-fill btn-magnify pull-right'
                                        onClick={() => this.setState({ addingPerson: true })}>
                                        <span className='btn-label'><i className='ti-plus' /></span>
                                    </button>
                                    <a href={this.context.api.people.exportUrl(this.tableState ? this.tableState.filters : null ,true, 'xlsx')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar excel</span>
                                        </button>
                                    </a>
                                    <a href={this.context.api.people.exportUrl(this.tableState ? this.tableState.filters : null, true,'pdf')}>
                                        <button
                                            className='btn btn-info btn-fill btn-magnify pull-right download-report'>
                                            <span className='btn-label'>Descargar PDF</span>
                                        </button>
                                    </a>
                                    <div className='clearfix'></div>
                                </div>

                                <Table
                                    pageSizes={[10, 15, 25, 50, 100, 200]}
                                    defaultPageSize={50}
                                    rowIdAccessor={'id'}
                                    totalItems={this.props.usersMeta.totalItems}
                                    loadData={this.loadData}
                                    columns={this.tableDefinition}
                                    data={this.props.users}
                                    trProps={(row, index) => ({ onClick: () => this.setState({ detailingPerson: index }) })}
                                />
                            </div>

                        </div>
                    </div>

                </div>

                {this.state.addingPerson ?
                    <AdminUserFormModal
                        onHide={() => this.setState({ addingPerson: false })}
                        onSubmit={this.addPerson}
                        disabled={this.state.addingLoading}
                    />
                    : null}

                {this.state.editingPerson ?
                    <AdminUserFormModal
                        onHide={() => this.setState({ editingPerson: false })}
                        onSubmit={this.editPerson}
                        defaultValues={this.state.editingPerson}
                        photoUrl={this.state.editingPerson.photo ? this.context.api.appFiles.getUrl(this.state.editingPerson.photo.id) : undefined}
                        editing
                        disabled={this.state.editingLoading}
                    />
                    : null}

                {this.state.deletingPerson ?
                    <DeleteAdminUserModal
                        person={this.state.deletingPerson}
                        onHide={() => this.setState({ deletingPerson: false })}
                        onConfirm={this.deletePerson}
                    />
                    : null}

                {this.state.detailingPerson !== false ?
                    <AdminUserDetailModal
                        person={this.props.users[this.state.detailingPerson]}
                        onHide={() => this.setState({ detailingPerson: false })}
                        canEdit={true}
                        canDownloadCredential={true}
                    />
                    : null}

            </div>
        );
    }
}

const mapStateToProps = ({ api: { users = [], usersMeta = {} } }) => {
    return { users, usersMeta }
};

export default connect(mapStateToProps)(AdminUsers);



// WEBPACK FOOTER //
// ./src/App/scenes/AppFrame/scenes/AdminUsers/index.jsx